import React from 'react';
import {
  Card, Typography, Button, Space, Tag, Popconfirm, Switch,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import Proptypes from 'prop-types';

import useAlarmRuleItem from './useAlarmRuleItem';
import styles from './AlarmRuleItem.module.less';

const {
  Title,
  Paragraph
} = Typography;
// const severityColor = {
//   critical: '#f50',
//   warning: '#F9D423',
//   info: '#2db7f5',
// };

function AlarmRuleItem(props) {

  const { t } = useTranslation();
  const {
    id,
    name,
    business_type_name,
    actions,
    bits_error,
    is_active,
    // conditions,
    // description,
    // severity,
  } = props;
  const {
    onEditAlarm,
    onDeleteAlarm,
    loadingDelete,
    isDefaulAlarm,
    isAdmin,
    onSetActive,
    loadingActive,
  } = useAlarmRuleItem({ id, name });

  if (isDefaulAlarm) return null;

  return (
    <Card className={styles.card_item}>
      <div className={styles.card_content}>
        <div className={styles.info_wrapper}>
          <Title className={styles.title_alarm} level={4}>
            {name}
          </Title>
          
          <Paragraph>{business_type_name}</Paragraph>

          {/* <Paragraph>{description.length === 0 ? 'Sin descripción'
          : description}</Paragraph> */}
          {/* <Tag color={severityColor[severity] || null}>{severity}</Tag> */}
          <Space size="small" align="end">
            <Tag>
              {`${bits_error.length} ${
                bits_error.length !== 1
                  ? t('views.dynamic_alarms.item_alarm.conditions')
                  : t('views.dynamic_alarms.item_alarm.condition')
              }`}
            </Tag>
            <Tag>
              {`${actions ? actions.length : false} ${actions && actions.length !== 1 ? t('views.dynamic_alarms.item_alarm.actions') : t('views.dynamic_alarms.item_alarm.action')
              }`}
            </Tag>
          </Space>
        </div>

        <div className={styles.fast_actions}>
          <Button shape="circle" type="text" onClick={onEditAlarm}>
            <FontAwesomeIcon icon={faPen} className={styles.icon} />
          </Button>

          {(isAdmin)
          && (
          <Popconfirm
            title={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_title')}
            okText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_ok')}
            cancelText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_cancel')}
            onConfirm={onDeleteAlarm}
          >
            <Button shape="circle" type="text" loading={loadingDelete}>
              <FontAwesomeIcon
                icon={faTrash}
                className={styles.icon}
                style={{ display: !loadingDelete ? 'inline-block' : 'none' }}
              />
            </Button>
          </Popconfirm>
          )}
        </div>

        <Switch
          className={styles.active_switch}
          checked={is_active}
          onChange={onSetActive}
          loading={loadingActive}
        />
      </div>
    </Card>
  );

}

AlarmRuleItem.propTypes = {
  id: Proptypes.string.isRequired,
  name: Proptypes.string.isRequired,
  bits_error: Proptypes.arrayOf(Proptypes.any),
  actions: Proptypes.arrayOf(Proptypes.any),
  // description: Proptypes.string,
  // severity: Proptypes.string.isRequired,k
  is_active: Proptypes.bool.isRequired,
};

AlarmRuleItem.defaultProps = {
  bits_error: [],
  actions: [],
  // description: '',
};

export default AlarmRuleItem;
